// D-GOV-10 Phase 5: OAuth2/PKCE login (replaces bearer-paste for IdP-backed instances).
// Thin SPA wrapper over @kontextwerk/web-common's framework-agnostic PKCE helpers.
import {
  beginLogin,
  clientIdForApp,
  completeLogin,
  discoverOAuthMode,
} from "@kontextwerk/web-common";

const CORE_BASE = "/core/v1";
// D-GOV-11: app-key for the per-UI client_id served via /v1/discovery; the IdP
// generates the real client_id, so it is read at runtime (no build-time default).
const APP_KEY = "admin";
const SCOPES = ["openid", "profile", "email", "groups"];

const redirectUri = () => `${window.location.origin}/callback`;

/** True if this instance offers an external OIDC issuer (I1) → show the SSO button. */
export async function oauthAvailable(): Promise<boolean> {
  try {
    return (await discoverOAuthMode(CORE_BASE)) !== null;
  } catch {
    return false;
  }
}

/** Begin the PKCE flow: redirect the browser to the IdP authorize endpoint. */
export async function startSsoLogin(): Promise<void> {
  const mode = await discoverOAuthMode(CORE_BASE);
  if (!mode) throw new Error("dieser Server bietet keinen OAuth-Login (kein I1-Issuer)");
  const url = await beginLogin({
    issuer: mode.issuer,
    clientId: clientIdForApp(mode, APP_KEY),
    redirectUri: redirectUri(),
    scopes: SCOPES,
  });
  window.location.assign(url);
}

/** Complete the callback: code → IdP token → KW-self token. Returns the KW token. */
export async function finishSsoLogin(search: string): Promise<string> {
  const mode = await discoverOAuthMode(CORE_BASE);
  if (!mode) throw new Error("kein OAuth-Issuer mehr konfiguriert");
  const p = new URLSearchParams(search);
  return completeLogin({
    coreBaseUrl: CORE_BASE,
    issuer: mode.issuer,
    clientId: clientIdForApp(mode, APP_KEY),
    redirectUri: redirectUri(),
    params: { code: p.get("code"), state: p.get("state"), error: p.get("error") },
  });
}
